export const exactPaths = [
  "/network-plan",
  "/single-network-selection",
  "/single-network-phone-type",
  "/single-network-number-type",
  "/multi-network-selection",
  "/multi-network-phone-type",
  "/multi-network-number-type",
  "/multi-network-number-information",
  "/digital-security-selection",
  "/checkout",
  "/activation/fixed-phone/activation-code",
  "/activation/fixed-phone/choose-service-plan",
  "/activation/fixed-phone/one-time-offer",
  "/activation/fixed-phone/security-plan-free-trial",
  "/activation/preloaded-sim/device-info",
  "/activation/preloaded-sim/choose-service-plan",
  "/activation/preloaded-sim/security-plan-upgrade",
  "/my-account/dashboard",
  "/my-account/payment-history",
  "/my-account/manage-profile",
  "/my-account/manage-cards",
  "/my-account/change-password",
  "/my-account/sim-service",
];

/** Paths where the header is relative (not fixed). All other pages keep fixed header. */
export const headerRelativePaths = [
  "/network-plan",
  "/checkout",
  "/activation/fixed-phone/activation-code",
  "/activation/fixed-phone/choose-service-plan",
  "/activation/fixed-phone/one-time-offer",
  "/activation/fixed-phone/security-plan-free-trial",
  "/activation/preloaded-sim/device-info",
  "/activation/preloaded-sim/choose-service-plan",
  "/activation/preloaded-sim/security-plan-upgrade",
];

export function isHeaderRelativeForPath(pathname: string): boolean {
  return headerRelativePaths.some(
    (path) => pathname === path || pathname.startsWith(path + "/"),
  );
}
